export default __webpack_public_path__ + "static/media/Background_00100.54222cd2.png";